import { render } from "./EditForkliftNoteInvoice.vue?vue&type=template&id=35bdfc05&scoped=true"
import script from "./EditForkliftNoteInvoice.vue?vue&type=script&lang=js"
export * from "./EditForkliftNoteInvoice.vue?vue&type=script&lang=js"

import "./EditForkliftNoteInvoice.vue?vue&type=style&index=0&id=35bdfc05&lang=css"
import "./EditForkliftNoteInvoice.vue?vue&type=style&index=1&id=35bdfc05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bdfc05"]])

export default __exports__